module.exports = __webpack_public_path__ + "static/media/less.59d487be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/less.png
// module id = 135
// module chunks = 0